import { render } from "./Modal.vue?vue&type=template&id=717622b2&scoped=true"
const script = {}

import "./Modal.vue?vue&type=style&index=0&id=717622b2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-717622b2"]])

export default __exports__